/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'

import Flipper from '../flipper'

import schraubstock_0 from 'images/schraubstock_0.jpg'
import schraubstock_1 from 'images/schraubstock_1.jpg'

import schneider_0 from 'images/schneider_0.jpg'
import schneider_1 from 'images/schneider_1.jpg'

import lampe_0 from 'images/lampe_0.jpg'
import lampe_1 from 'images/lampe_1.jpg'

const queryString = require('query-string')

export function AppComponent() {
  const parsed = queryString.parse(location.search)
  const route = 'f' in parsed ? parsed.f : ''

  return (
    <div className='index'>
      {route === 'schraubstock' && (
        <Flipper
          before={schraubstock_0}
          after={schraubstock_1}
          sourceText='my mechanics/youtube'
          sourceUrl='https://www.youtube.com/watch?v=U2jNeObHnZY'
        />
      )}
      {route === 'schneider' && (
        <Flipper
          before={schneider_0}
          after={schneider_1}
          sourceText='my mechanics/youtube'
          sourceUrl='https://youtu.be/kqLoC2U5u-g'
        />
      )}
      {route === 'lampe' && (
        <Flipper
          before={lampe_0}
          after={lampe_1}
          sourceText='my mechanics/youtube'
          sourceUrl='https://www.youtube.com/watch?v=R2M83iah9fo'
        />
      )}
      {!route && <div>Nichts zu laden</div>}
    </div>
  )
}
